<app-header></app-header>
<!--Breadcrumb-->
        <div>
            <div class="bannerimg cover-image bg-background3" data-image-src="assets/images/banners/banner2.jpg">
                <div class="header-text mb-0">
                    <div class="container">
                        <div class="text-center text-white ">
                            <h1 class="mb-0">Fixed Price Car Seller Acceptance Detail</h1>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--/Breadcrumb-->

        <!--listing-->
        <section class="sptb fixed-price-main-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div id="uploaded-by"  class="tab-pane active">
                                <div class="card mb-3">
                                    <div class="padding_125">
                                        <div class="table-responsive border-top">
                                            <table class="table table-bordered table-hover text-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th>Car Name</th>
                                                        <th>Car Id</th>
                                                        <!-- <th>Car Status</th> -->
                                                        <th>Offer Price</th>
                                                        <th>Offer Date</th>
                                                        <th>Offer Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of carMakeOfferListCarDetail">
                                                        <td class="text-primary">{{item.title}}</td>
                                                        <td>{{item.unique_id}}</td>        
                                                        <!-- <td>{{item.st}}</td> -->                      
                                                        <td class="font-weight-semibold fs-16">₹{{item.amount}}</td>
                                                        <td>{{item.okshan_end_date | date:'yyyy-MM-dd'}}</td>
                                                        <td>{{item.offer_status_text}}</td>
                                                        <td>
                                                            <a class="btn btn-sm text-white mb-1" data-toggle="tooltip" data-original-title="View" (click)="getViewAcceptOfferCarsListConfirmation(item.car_id, item.profile_id, item.seller_acceptance)" title="{{item.seller_acceptance === 0 ? 'Accept Offer' : 'Already Accepted Offer'}}" 
                                                            style="{{item.seller_acceptance === 0 ? 'background-color:#e72a1a': ' background-color: green'}}">   
                                                                <i class="fa {{item.seller_acceptance === 0 ? 'fa-hand-o-right' : 'fa-arrow-up'}}"></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
     
        <!-- /make an offer modal -->

<app-footer></app-footer>
